import { useState } from "react";

/*
Purpose:
Allows creators to submit a bid for a campaign.

Creators specify:
• bid amount
• promotion message

Later this will connect to Django API.
*/

export default function BidModal({ campaign, closeModal }) {

  const [bidAmount, setBidAmount] = useState("");
  const [message, setMessage] = useState("");

  const submitBid = () => {

    const bidData = {
      campaign_id: campaign.id,
      bidAmount,
      message
    };

    console.log("Bid Submitted:", bidData);

    // Later send to backend API

    closeModal();
  };

  return (

    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">

      <div className="bg-yellow-200 p-6 rounded-xl w-96">

        <h2 className="text-xl text-black font-bold mb-4">
          Submit Bid
        </h2>

        <p className="text-sm text-black mb-4">
          Campaign: {campaign.title}
        </p>

        <input
          type="number"
          placeholder="Your Bid Amount"
          value={bidAmount}
          onChange={(e) => setBidAmount(e.target.value)}
          className="w-full text-black border p-3 rounded-lg mb-3"
        />

        <textarea
          placeholder="Promotion Strategy Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full text-black border p-3 rounded-lg mb-4"
        />

        <div className="flex justify-end gap-3">

          <button
            onClick={closeModal}
            className="px-4 py-2 text-black border rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={submitBid}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg"
          >
            Submit Bid
          </button>

        </div>

      </div>

    </div>
  );
}